import React from "react";
import HeroSection from "../containers/Crm/HeroSection";
import Section_one from "../containers/Crm/Section_one";
import CrmOffice from "../containers/Crm/Crmoffice";
import Tecno from "../containers/Crm/CrmWork";




const CrmDevelopment = () => {
  return (
    <div>
      <HeroSection />
      <Section_one />
      <div className="bg-gradient-to-b from-[#F2FBFE] to-white">

      <CrmOffice />
      </div>
      <Tecno />
    
      
    </div>
  );
};

export default CrmDevelopment;
